import { cloneDeep } from "lodash";
import { DRAFT_STATUS } from "@/constants";

export const duplicateUnit = (unit) => {
  const clonedUnit = cloneDeep(unit);

  clonedUnit.rooms =
    clonedUnit?.rooms?.map((room) => {
      const dupRoom = duplicateRoom(room);
      dupRoom.status = DRAFT_STATUS;
      return dupRoom;
    }) ?? [];

  clonedUnit.status = DRAFT_STATUS;

  return {
    ...clonedUnit,
    id: undefined,
    is_not_valid: false,
    newly_added: true,
    created_at: undefined,
    updated_at: undefined,
    updated_by: undefined,
    archived_at: undefined,
  };
};

export const duplicateRoom = (room) => {
  const clonedRoom = cloneDeep(room);
  clonedRoom?.product_prices?.forEach((pprice) => {
    pprice.id = undefined;
  });
  return {
    ...clonedRoom,
    id: undefined,
    is_not_valid: false,
    status: DRAFT_STATUS,
    is_not_valid_amenities: { Amenities: false, Safety: false },
    newly_added: true,
    created_at: undefined,
    updated_at: undefined,
    updated_by: undefined,
    archived_at: undefined,
  };
};
